import { ref, onMounted } from 'vue'

const isDeepDebugMode = ref(false)

export const useDeepDebug = () => {
  onMounted(() => {
    if (process.client) {
      const urlParams = new URLSearchParams(window.location.search)
      isDeepDebugMode.value = urlParams.get('deepdebug') === 'true'
      
      if (isDeepDebugMode.value) {
        console.log('🔍 Deep Debug Mode activado - mostrando contenido no publicado')
      }
    }
  })

  return {
    isDeepDebugMode
  }
}

